import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles.css";
import "./login.css";
import "./data.css";
import "./governance.css";
import "./scheduling.css";
import "./analytics.css";
import "./appointments.css";
createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
